import React, { useEffect, useState } from 'react';
import { useGetCommodities, usePutCommodities } from '../../hooks/api/configurationApi';
import CustomCheckBox from '../../../../components/CustomizedComponents/CustomCheckBox';
import { FormattedMessage, useIntl } from 'react-intl';
import DetailWrapper from '../../../../components/CardRow/DetailWrapper';
import DefaultButton from '../../../../components/Button/DefaultButton';
import ButtonWrapper from '../../../../components/Button/ButtonWrapper';
import CustomSnackBar from '../../../../components/CustomizedComponents/CustomSnackbar';
import PropTypes from 'prop-types';

const cancel = 'app.buttons.cancel';
const save = 'app.buttons.save';

const AutomaticPurchase = ({ editable, setEditable }) => {
  const intl = useIntl();
  const { getCommodities, data } = useGetCommodities();
  const { putCommodities, error: putCommoditiesError, loading: putCommoditiesLoading } = usePutCommodities();
  const [commoditiesState, setCommoditiesState] = useState({});
  const success = intl.formatMessage({ id: 'app.action.saved' });
  const [message, setMessage] = useState(success);
  const [open, setOpen] = useState(false);
  const [issues, setIssues] = useState(null);

  useEffect(() => {
    getCommodities();
  }, [getCommodities]);

  useEffect(() => {
    if (putCommoditiesError) {
      setMessage(putCommoditiesError?.data?.message);
      setIssues(putCommoditiesError?.data?.issues);
    } else {
      setMessage(success);
      setIssues(null);
    }
  }, [success, putCommoditiesError]);

  useEffect(() => {
    if (data) {
      setCommoditiesState(
        data.reduce((accumulator, commodity) => {
          accumulator[commodity.id] = {
            id: commodity.id,
            name: commodity.name,
            autoPurchase: commodity.autoPurchase,
          };

          return accumulator;
        }, {}),
      );
    }
  }, [data]);

  const updateValue = (actualCheckboxObj) => {
    setCommoditiesState((currentState) => {
      return {
        ...currentState,
        [actualCheckboxObj.id]: {
          ...currentState[actualCheckboxObj.id],
          autoPurchase: !actualCheckboxObj.autoPurchase,
        },
      };
    });
  };

  return (
    <DetailWrapper>
      <table>
        <tbody>
          {Object.values(commoditiesState).map((value, index) => {
            return (
              <tr key={index}>
                <td>{value.name}</td>
                <td>
                  <CustomCheckBox
                    checked={value.autoPurchase}
                    disabled={!editable}
                    onChange={() => {
                      updateValue(value);
                    }}
                  />
                </td>
                <td>
                  <FormattedMessage id={value.autoPurchase ? 'app.configuration.automaticPurchase.on' : 'app.configuration.automaticPurchase.off'} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <ButtonWrapper>
        <DefaultButton
          primary={false}
          disabled={!editable}
          title={cancel}
          onClick={() => {
            setEditable(!editable);
          }}
        />
        <DefaultButton
          primary={true}
          disabled={!editable}
          type="submit"
          title={save}
          loaders={[putCommoditiesLoading]}
          onClick={() => {
            putCommodities(Object.values(commoditiesState).map((commodity) => ({ id: commodity.id, autoPurchase: commodity.autoPurchase })));
            setOpen(true);
            setEditable(false);
          }}
        />
      </ButtonWrapper>
      {!putCommoditiesLoading && message && (
        <CustomSnackBar status={!putCommoditiesError ? 'success' : 'error'} message={message} setOpen={setOpen} open={open} />
      )}
      {!putCommoditiesLoading && issues && issues.map((issue) => <CustomSnackBar key={issue} status={'error'} message={issue} setOpen={setOpen} open={open} />)}
    </DetailWrapper>
  );
};

AutomaticPurchase.propTypes = {
  editable: PropTypes.bool,
  setEditable: PropTypes.func,
};

export default AutomaticPurchase;
